module.exports = __webpack_public_path__ + "static/media/198.451734c6.jpg";